/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
export const BOARD_URL_PREFIX = "board-data";
export const BOARD_DELETE_URL_PREFIX = "boards";
export var ApiMethods;
(function (ApiMethods) {
    ApiMethods["GET"] = "GET";
    ApiMethods["POST"] = "POST";
    ApiMethods["DELETE"] = "DELETE";
})(ApiMethods || (ApiMethods = {}));
export var BoardObjectTypes;
(function (BoardObjectTypes) {
    BoardObjectTypes["BOARD"] = "board";
    BoardObjectTypes["VIEW"] = "view";
    BoardObjectTypes["ZONE"] = "zone";
    BoardObjectTypes["COMPONENT"] = "component";
    BoardObjectTypes["VIEW_BOARD"] = "view_board";
    BoardObjectTypes["ZONE_VIEW"] = "zone_view";
    BoardObjectTypes["COMPONENT_ZONE"] = "component_zone";
})(BoardObjectTypes || (BoardObjectTypes = {}));
export const BOARD_ENDPOINTS = {
    // Standard endpoints
    BOARD: `${BOARD_URL_PREFIX}/${BoardObjectTypes.BOARD}`,
    BOARD_VIEWS: `${BOARD_URL_PREFIX}/${BoardObjectTypes.VIEW_BOARD}`,
    VIEW: `${BOARD_URL_PREFIX}/${BoardObjectTypes.VIEW}`,
    VIEW_ZONES: `${BOARD_URL_PREFIX}/${BoardObjectTypes.ZONE_VIEW}`,
    ZONE: `${BOARD_URL_PREFIX}/${BoardObjectTypes.ZONE}`,
    ZONE_COMPONENTS: `${BOARD_URL_PREFIX}/${BoardObjectTypes.COMPONENT_ZONE}`,
    COMPONENT: `${BOARD_URL_PREFIX}/${BoardObjectTypes.COMPONENT}`,
    // Delete endpoints
    DELETE_BOARD: `${BOARD_DELETE_URL_PREFIX}/${BoardObjectTypes.BOARD}`,
    DELETE_ZONE: `${BOARD_DELETE_URL_PREFIX}/${BoardObjectTypes.ZONE}`,
    DELETE_COMPONENT: `${BOARD_DELETE_URL_PREFIX}/${BoardObjectTypes.COMPONENT}`,
};
export const ACTION_ENDPOINTS = {
    GET_ACTIONS: "action",
    RUN_ACTION: "run-action",
};
